import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "current-setup__item" }
const _hoisted_2 = { class: "current-setup__value" }
const _hoisted_3 = {
  key: 0,
  class: "current-setup__numbers"
}
const _hoisted_4 = { class: "current-setup__difference" }
const _hoisted_5 = {
  key: 1,
  class: "current-setup__numbers current-setup__numbers--inactive"
}
const _hoisted_6 = { class: "current-setup__value" }
const _hoisted_7 = {
  key: 0,
  class: "current-setup__numbers"
}
const _hoisted_8 = { class: "current-setup__difference" }
const _hoisted_9 = {
  key: 1,
  class: "current-setup__numbers current-setup__numbers--inactive"
}
const _hoisted_10 = { class: "current-setup__item" }
const _hoisted_11 = { class: "current-setup__value" }
const _hoisted_12 = {
  key: 0,
  class: "current-setup__numbers"
}
const _hoisted_13 = { class: "current-setup__difference" }
const _hoisted_14 = {
  key: 1,
  class: "current-setup__numbers current-setup__numbers--inactive"
}
const _hoisted_15 = { class: "current-setup__value" }
const _hoisted_16 = {
  key: 0,
  class: "current-setup__numbers"
}
const _hoisted_17 = { class: "current-setup__difference" }
const _hoisted_18 = {
  key: 1,
  class: "current-setup__numbers current-setup__numbers--inactive"
}

import { computed, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useMeasurementStore } from '@/store/measurementStore'
import { usePositionStore } from '@/store/positionStore'
import { usePreferenceStore } from '@/store/preferenceStore'
import { BfFlex } from '@finetic/bikefitting-ui'
import { useI18n } from 'vue-i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'CurrentSetup',
  setup(__props) {

const { t } = useI18n()
const measurementStore = useMeasurementStore()
const positionStore = usePositionStore()
const preferenceStore = usePreferenceStore()
const { selectedMeasurement } = storeToRefs(measurementStore)
const {
  absolutePosition,
  positionChange,
  isCalibrated,
  isLatestMeasurementCalibrated,
} = storeToRefs(positionStore)
const { hasPositioningMotors } = storeToRefs(preferenceStore)

const handlebarX = computed(() => absolutePosition.value.handlebarX)
const handlebarY = computed(() => absolutePosition.value.handlebarY)
const saddleX = computed(() => absolutePosition.value.saddleX)
const saddleY = computed(() => absolutePosition.value.saddleY)

const handlebarXChange = computed(() => positionChange.value.handlebarX)
const handlebarYChange = computed(() => positionChange.value.handlebarY)
const saddleXChange = computed(() => positionChange.value.saddleX)
const saddleYChange = computed(() => positionChange.value.saddleY)

watch(
  handlebarX,
  () => (selectedMeasurement.value.handlebar.x = handlebarX.value),
)
watch(
  handlebarY,
  () => (selectedMeasurement.value.handlebar.y = handlebarY.value),
)
watch(saddleX, () => (selectedMeasurement.value.saddle.x = saddleX.value))
watch(saddleY, () => (selectedMeasurement.value.saddle.y = saddleY.value))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BfFlex), {
    gap: "1.2rem",
    justify: "center"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h2", null, _toDisplayString(_unref(t)('common.bike.saddle')), 1),
        (_unref(selectedMeasurement))
          ? (_openBlock(), _createBlock(_unref(BfFlex), {
              key: 0,
              gap: "0.8rem"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("h3", null, _toDisplayString(_unref(t)('common.position.x')), 1),
                  (
              !_unref(hasPositioningMotors) ||
              (_unref(isCalibrated) && _unref(isLatestMeasurementCalibrated))
            )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createTextVNode(_toDisplayString(saddleX.value) + " " + _toDisplayString(_unref(t)('common.unit.mm')) + " ", 1),
                        _createElementVNode("span", _hoisted_4, "(" + _toDisplayString(`${saddleXChange.value} ${_unref(t)('common.unit.mm')}`) + ")", 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(t)('common.notCalibrated')), 1))
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("h3", null, _toDisplayString(_unref(t)('common.position.y')), 1),
                  (
              !_unref(hasPositioningMotors) ||
              (_unref(isCalibrated) && _unref(isLatestMeasurementCalibrated))
            )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createTextVNode(_toDisplayString(saddleY.value) + " " + _toDisplayString(_unref(t)('common.unit.mm')) + " ", 1),
                        _createElementVNode("span", _hoisted_8, "(" + _toDisplayString(`${saddleYChange.value} ${_unref(t)('common.unit.mm')}`) + ")", 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(t)('common.notCalibrated')), 1))
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("p", null, _toDisplayString(_unref(selectedMeasurement)?.saddle.active
            ? `${_unref(selectedMeasurement)?.saddle.active.SADDLE_BRAND} ${_unref(selectedMeasurement)?.saddle.active.SADDLE_MODEL}`
            : '-'), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("h2", null, _toDisplayString(_unref(t)('common.bike.handlebar')), 1),
        (_unref(selectedMeasurement))
          ? (_openBlock(), _createBlock(_unref(BfFlex), {
              key: 0,
              gap: "0.8rem"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("h3", null, _toDisplayString(_unref(t)('common.position.x')), 1),
                  (
              !_unref(hasPositioningMotors) ||
              (_unref(isCalibrated) && _unref(isLatestMeasurementCalibrated))
            )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createTextVNode(_toDisplayString(Math.abs(handlebarX.value)) + " " + _toDisplayString(_unref(t)('common.unit.mm')) + " ", 1),
                        _createElementVNode("span", _hoisted_13, "(" + _toDisplayString(`${handlebarXChange.value * -1} ${_unref(t)('common.unit.mm')}`) + ")", 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_unref(t)('common.notCalibrated')), 1))
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("h3", null, _toDisplayString(_unref(t)('common.position.y')), 1),
                  (
              !_unref(hasPositioningMotors) ||
              (_unref(isCalibrated) && _unref(isLatestMeasurementCalibrated))
            )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createTextVNode(_toDisplayString(handlebarY.value) + " " + _toDisplayString(_unref(t)('common.unit.mm')) + " ", 1),
                        _createElementVNode("span", _hoisted_17, "(" + _toDisplayString(`${handlebarYChange.value} ${_unref(t)('common.unit.mm')}`) + ")", 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_unref(t)('common.notCalibrated')), 1))
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("p", null, _toDisplayString(_unref(selectedMeasurement)?.handlebar.active
            ? `${_unref(selectedMeasurement)?.handlebar.active.HANDLEBAR_BRAND} ${_unref(selectedMeasurement)?.handlebar.active.HANDLEBAR_MODEL}`
            : '-'), 1)
      ])
    ]),
    _: 1
  }))
}
}

})